<template>
  <div class="animated revealUp">
    <div class="white-wrapper">
      <div class="section-title">
        {{ $t("DCR Finance") }}
      </div>
      <div class="mt-3 mb-2">
        <div class="row">
          <div class="col-lg-4 col-xl-3 align-self-center mb-3">
            <div class="dropdown-curve-container">
              <label
                :class="
                  dropDown.cinemas && dropDown.cinemas.length > 0
                    ? 'shift-up'
                    : ''
                "
                >{{ $t("select") }} {{ $tc("cinema", 1) }}</label
              >
              <multiselect
                :disabled="isRoleID"
                :options="dropDown.cinemas"
                v-model="dropDown.selectedCinema"
                :searchable="true"
                label="cine_name"
                track-by="cine_id"
                placeholder="Select Cinema"
                @input="onSelectCinema($event)"
                :allowEmpty="false"
                :showLabels="false"
              ></multiselect>
            </div>
          </div>
          <div class="col-lg-4 col-xl-3 align-self-center mb-3">
            <div class="input-material">
              <div class="add-datepicker">
                <!-- <button class="btn-clearDate" v-if="fromDate">
                  ✖
                </button> -->
                <Datepicker
                  :monday-first="true"
                  type="date"
                  ref="programaticOpen"
                  v-model="fromDate"
                  v-validate="'required'"
                ></Datepicker>
                <label :class="fromDate ? 'active' : ''">
                  <!-- {{ $t("show") }} -->
                  {{ $t("fromdate") }}
                </label>
              </div>
            </div>
          </div>
          <div class="col-lg-4 col-xl-3 align-self-center mb-3">
            <div class="input-material">
              <div class="add-datepicker">
                <!-- <button class="btn-clearDate" v-if="fromDate">
                  ✖
                </button> -->
                <Datepicker
                  :monday-first="true"
                  type="date"
                  ref="programaticOpen"
                  v-model="toDate"
                  v-validate="'required'"
                ></Datepicker>
                <label :class="toDate ? 'active' : ''">
                  <!-- {{ $t("show") }} -->
                  {{ $t("To Date") }}
                </label>
              </div>
            </div>
          </div>

          <div class="col-lg-6 col-xl-2 align-self-center mb-3">
            <button
              class="btn-blue-lg w-100"
              @click.prevent="getDcrFinanceRecords()"
            >
              {{ $t("fetch") }}
              {{ $t("report") }}
            </button>
          </div>

          <div
            v-if="dcrFinanceRecords.length > 0"
            class="mr-3 w-100 align-self-center mb-3 d-flex justify-content-end align-items-center"
          >
            <div class="mx-1">{{ $t("download") }} as:</div>
            <!-- s -->

            <a
              target="_blank"
              @click="getDcrFinanceRecords('Y')"
              title="Download as Excel"
              download
            >
              <img
                class="mx-1"
                src="@/assets/img/icons/excel.svg"
                height="25"
                width="25"
              />
            </a>
          </div>
        </div>
      </div>
      <div class="swc-report">
        <table class="swc-report-table" border="1">
          <thead class="bg-lightgrey font-weight-bold">
            <tr>
              <td rowspan="3">S.No</td>
              <td rowspan="3">Sales Point</td>
            </tr>
            <tr>
              <td colspan="3">Gross Sales</td>
              <td colspan="3">Card/FonePay Sales</td>
              <td colspan="2">Short/Excess</td>
              <td colspan="2">From Facilites</td>
            </tr>
            <tr>
              <td>Ticket</td>
              <td>Food</td>
              <td>Total</td>
              <td>Ticket</td>
              <td>Food</td>
              <td>Total</td>
              <td>Ticket</td>
              <td>Food</td>
              <td>Ticket</td>
              <td>Food</td>
            </tr>
          </thead>
          <tbody v-if="dcrFinanceRecords.length > 0">
            <tr
              v-for="(dcrFinanceObj, dcrFinanceIndex) in dcrFinanceRecords"
              :key="dcrFinanceIndex"
            >
              <td class="text-left">{{ dcrFinanceIndex + 1 }}</td>
              <td class="text-left">
                {{
                  dcrFinanceObj.hardware_name
                    ? dcrFinanceObj.hardware_name
                    : `POS_${dcrFinanceObj.cine_name}`
                }}
              </td>
              <td class="text-right">
                {{
                  dcrFinanceObj.tickets
                    ? currFormat(dcrFinanceObj.tickets)
                    : "-"
                }}
              </td>
              <td class="text-right">
                {{
                  dcrFinanceObj.fnb_tickets
                    ? currFormat(dcrFinanceObj.fnb_tickets)
                    : "-"
                }}
              </td>
              <td class="text-right">
                {{
                  currFormat(
                    +parseFloat(dcrFinanceObj.tickets || 0) +
                      +parseFloat(dcrFinanceObj.fnb_tickets || 0)
                  ) || "-"
                }}
              </td>
              <td class="text-right">
                {{
                  dcrFinanceObj.card_tickets
                    ? currFormat(dcrFinanceObj.card_tickets)
                    : "-"
                }}
              </td>
              <td class="text-right">
                {{
                  dcrFinanceObj.card_fnb_tickets
                    ? currFormat(dcrFinanceObj.card_fnb_tickets)
                    : "-"
                }}
              </td>
              <td class="text-right">
                {{
                  dcrFinanceObj.card_total
                    ? currFormat(dcrFinanceObj.card_total)
                    : "-"
                }}
              </td>
              <td class="text-right">
                {{
                  dcrFinanceObj.excess_tickets
                    ? currFormat(dcrFinanceObj.excess_tickets)
                    : "-"
                }}
              </td>
              <td class="text-right">
                {{
                  dcrFinanceObj.excess_fnb_tickets
                    ? currFormat(dcrFinanceObj.excess_fnb_tickets)
                    : "-"
                }}
              </td>
              <td class="text-right">
                {{
                  dcrFinanceObj.facility_tickets
                    ? currFormat(dcrFinanceObj.facility_tickets)
                    : "-"
                }}
              </td>
              <td class="text-right">
                {{
                  dcrFinanceObj.facility_fnb_tickets
                    ? currFormat(dcrFinanceObj.facility_fnb_tickets)
                    : "-"
                }}
              </td>
            </tr>
            <tr class="bg-lightgrey font-weight-bold">
              <td class="text-left"></td>
              <td class="text-left">Total</td>
              <td class="text-right">
                {{
                  currFormat(
                    dcrFinanceRecords.reduce((acc, { tickets }) => {
                      return acc + +parseFloat(tickets || 0);
                    }, 0)
                  )
                }}
              </td>
              <td class="text-right">
                {{
                  currFormat(
                    dcrFinanceRecords.reduce((acc, { fnb_tickets }) => {
                      return acc + +parseFloat(fnb_tickets || 0);
                    }, 0)
                  )
                }}
              </td>
              <td class="text-right">
                {{
                  currFormat(
                    dcrFinanceRecords.reduce(
                      (acc, { tickets, fnb_tickets }) => {
                        return (
                          acc +
                          +parseFloat(fnb_tickets || 0) +
                          +parseFloat(tickets || 0)
                        );
                      },
                      0
                    )
                  )
                }}
              </td>
              <td class="text-right">
                {{
                  currFormat(
                    dcrFinanceRecords.reduce((acc, { card_tickets }) => {
                      return acc + +parseFloat(card_tickets || 0);
                    }, 0)
                  )
                }}
              </td>
              <td class="text-right">
                {{
                  currFormat(
                    dcrFinanceRecords.reduce((acc, { card_fnb_tickets }) => {
                      return acc + +parseFloat(card_fnb_tickets || 0);
                    }, 0)
                  )
                }}
              </td>
              <td class="text-right">
                {{
                  currFormat(
                    dcrFinanceRecords.reduce((acc, { card_total }) => {
                      return acc + +parseFloat(card_total || 0);
                    }, 0)
                  )
                }}
              </td>
              <td class="text-right">
                {{
                  currFormat(
                    dcrFinanceRecords.reduce((acc, { excess_tickets }) => {
                      return acc + +parseFloat(excess_tickets || 0);
                    }, 0)
                  )
                }}
              </td>
              <td class="text-right">
                {{
                  currFormat(
                    dcrFinanceRecords.reduce((acc, { excess_fnb_tickets }) => {
                      return acc + +parseFloat(excess_fnb_tickets || 0);
                    }, 0)
                  )
                }}
              </td>
              <td class="text-right">
                {{
                  currFormat(
                    dcrFinanceRecords.reduce((acc, { facility_tickets }) => {
                      return acc + +parseFloat(facility_tickets || 0);
                    }, 0)
                  )
                }}
              </td>
              <td class="text-right">
                {{
                  currFormat(
                    dcrFinanceRecords.reduce(
                      (acc, { facility_fnb_tickets }) => {
                        return acc + +parseFloat(facility_fnb_tickets || 0);
                      },
                      0
                    )
                  )
                }}
              </td>
            </tr>
          </tbody>
          <tbody v-if="dcrFinanceRecords.length == 0">
            <tr>
              <td colspan="12">
                <NoRecords />
              </td>
            </tr>
          </tbody>
        </table>

        <!-- Summary Details -->
        <div class="section-title my-2">Summary</div>
        <table class="swc-report-table w-50 mt-2" border="1">
          <tr class="bg-lightgrey font-weight-bold">
            <td class="text-left">S.No.</td>
            <td class="text-left">Particulars</td>
            <td class="text-left">Amount</td>
          </tr>
          <tr>
            <td class="text-left">1</td>
            <td class="text-left">Ticket Sales</td>
            <td class="text-left">
              {{ currFormat(summaryData.tickets) || 0 }}
            </td>
          </tr>
          <tr>
            <td class="text-left">2</td>
            <td class="text-left">Food Sales</td>
            <td class="text-left">
              {{ currFormat(summaryData.fnb_tickets) || 0 }}
            </td>
          </tr>
          <tr>
            <td class="text-left">3</td>
            <td class="text-left">3D Glass Rental Income</td>
            <td class="text-left">{{ currFormat(summaryData["3DAmount"]) }}</td>
          </tr>
          <tr>
            <td class="text-left">4</td>
            <td class="text-left">Excess/Short</td>
            <td class="text-left">{{ currFormat(summaryData.excess) }}</td>
          </tr>
          <tr class="bg-lightgrey font-weight-bold">
            <td class="text-left" colspan="2">Total</td>
            <td class="text-left">
              {{
                currFormat(
                  +parseFloat(summaryData.tickets) +
                    +parseFloat(summaryData.fnb_tickets || 0) +
                    +parseFloat(summaryData["3DAmount"]) +
                    +parseFloat(summaryData.excess)
                )
              }}
            </td>
          </tr>
        </table>

        <!-- Summary Details -->

        <!-- Payment Wise Details -->
        <div class="section-title my-2">Details</div>
        <table class="swc-report-table w-50 mt-2" border="1">
          <thead class="bg-lightgrey font-weight-bold">
            <td>S.No.</td>
            <td>Payment Details</td>
            <td>Amount</td>
          </thead>
          <tbody v-if="paymentWiseSummary.length">
            <tr
              v-for="(paymentObj, paymentIndex) in paymentWiseSummary"
              :key="paymentIndex"
            >
              <td class="text-left">{{ paymentIndex + 1 }}</td>
              <td class="text-right">{{ paymentObj.pm_payment_mode }}</td>
              <td class="text-right">{{ currFormat(paymentObj.total) }}</td>
            </tr>
            <tr class="bg-lightgrey font-weight-bold">
              <td colspan="2">Total</td>
              <td class="text-right">
                {{
                  currFormat(
                    paymentWiseSummary.reduce((acc, { total }) => {
                      return acc + +parseFloat(total);
                    }, 0)
                  )
                }}
              </td>
            </tr>
            <tr class="font-weight-bold">
              <td colspan="2">Total Number of Transactions (BO + FNB)</td>
              <td class="text-right">
                {{
                  paymentWiseSummary.reduce((acc, { total_counts }) => {
                    return acc + +parseFloat(total_counts);
                  }, 0)
                }}
              </td>
            </tr>
          </tbody>
          <tbody v-if="paymentWiseSummary.length == 0">
            <tr>
              <td colspan="3">
                <NoRecords />
              </td>
            </tr>
          </tbody>
        </table>
        <!-- Payment Wise Details -->
      </div>
    </div>
  </div>
</template>
<script>
import { BASEURL } from "@/config/index";
import MasterService from "@/services/MasterService";
import ReportsService from "@/services/ReportsService-v2";
import moment from "moment";
import NoRecords from "@/components/Partials/NoRecords.vue";
import CinemasService from "@/services/CinemasService";
import xlsx from "json-as-xlsx";
import VueHtml2pdf from "vue-html2pdf";
import * as XLSX from "xlsx";

export default {
  components: {
    NoRecords,
    VueHtml2pdf,
  },
  data() {
    return {
      BASEURL,
      isRoleID: false,
      submitted: false,
      dropDown: {
        cinemas: [],
        selectedCinema: null,
        selectedCinemaName: null,
        selectedCinemaId: "",
      },
      fromDate: new Date(),
      toDate: new Date(),
      dcrFinanceRecords: [],
      excelFilePath: "",
      summaryData: {},
      paymentWiseSummary: [],
    };
  },
  beforeMount() {
    let CinemaObj = this.$store.getters.getSelectedDropDownCinema;
    let obj = this.secureStore.get("USINFO").cinema_id;
    this.getCinemaList(obj);
    // if (CinemaObj) {
    //   this.onSelectCinema(CinemaObj);
    // }
  },
  watch: {
    // "$store.getters.getSelectedDropDownCinema": function(CinemaObj) {
    //   if (CinemaObj) {
    //     this.onSelectCinema(CinemaObj);
    //   }
    // },
    excelFilePath(value) {
      this.excelFilePath = value;
    },
  },
  mounted() {},
  methods: {
    moment,
    getCinemaList: function (cine_id) {
      MasterService.GetCinemas({ cine_id: cine_id })
        .then((response) => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.dropDown.cinemas = data.Records;
            this.CinemasCopy = data.Records;
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError);
    },
    onSelectCinema: function (event) {
      this.dropDown.selectedCinema = event;
      this.dropDown.selectedCinemaName = event.cine_name;
      this.dropDown.selectedCinemaId = event.cine_id;
      this.$store.dispatch("selectDropdownCinema", event);
    },
    getDcrFinanceRecords(isExcelDownload = "N") {
      if (!this.dropDown.selectedCinemaId) {
        return this.$toasted.show("Select Cinema");
      } else if (!this.fromDate) {
        return this.$toasted.show("Select From Date");
      } else if (!this.toDate) {
        return this.$toasted.show("Select To Date");
      } else if(moment(moment(this.toDate).format('YYYY-MM-DD')).isBefore(moment(this.fromDate).format('YYYY-MM-DD'))) {
        return this.$toasted.show("Please Select Valid Date Range");
      } else {
        let loader = this.$loading.show();
        let payload = {
          cinema_id: this.dropDown.selectedCinemaId,
          fromDate: moment(this.fromDate).format("YYYY-MM-DD"),
          toDate: moment(this.toDate).format("YYYY-MM-DD"),
        };

        if (isExcelDownload == "Y") {
          payload["isExcel"] = "Y";
        }
        ReportsService.getDCRFinanceReport(payload)
          .then((response) => {
            const { data } = response;
            if (data.status && data.excelPath && isExcelDownload == "Y") {
              window.open(data.excelPath, "_blank");
            } else if (data.status && data.Records.length > 0) {
              this.dcrFinanceRecords = [...data.Records];
              this.summaryData = { ...data.Summary };
              this.paymentWiseSummary = [...data.paymentWiseSummary];
            } else {
              this.$toasted.show(data.message);
            }
            loader.hide();
          })
          .catch(this._CatchError)
          .finally(() => {
            setTimeout(() => {
              loader.hide();
            }, 100);
          });
      }
    },
  },
};
</script>

<style>
.concession-analysis-table {
  width: 100%;
  border: 1px solid #787878;
}

.concession-analysis-table thead {
  text-align: center;
  background-color: #dddedf;
}

.concession-analysis-table thead th {
  padding: 5px;
  border: 1px solid #000;
}

.concession-analysis-table tbody {
  border-bottom: 1px solid #000;
}

.concession-analysis-table tbody td {
  padding: 2.5px 5px;
  border-left: 1px solid #787878;
  border-right: 1px solid #787878;
}

.concession-analysis-table tbody td p {
  font-weight: bold;
  margin-bottom: 0;
}
.gcamp-tr td {
  width: 13%;
  border: 1px solid #000;
}

.swc-report-table {
  table-layout: auto !important;
  overflow-x: scroll !important;
  border: 1px solid black;
}
.swc-report-table td {
  white-space: nowrap;
}
.swc-report-table th {
  white-space: nowrap !important;
  border: 1px solid black !important;
}
.swc_table_header th {
  border: 1px solid black !important;
}
.no_border {
  border: 0px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/ReportsContainer/dcrFinance.vue